import { BriefcaseIcon } from "@heroicons/react/outline";
const companyChangeProcesses = [
  {
    id: "OfficialsShareholdersAuthorisedPersons",
    title: "Officials/Shareholders/Authorized Persons",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "officials-shareholders-authorized-person-changes",
  },
  {
    id: "ArticlesOfAssociation",
    title: "Articles Of Association",
    description:
      "Initiate a new application with just a few clicks and you will be on your way to amend your articles.",
    icon: <BriefcaseIcon />,
    hash: "articles-of-association-changes",
    disabled: true,
  },
  {
    id: "ShareCapital",
    title: "Share Capital",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "share-capital-changes",
    disabled: false,
  },
  {
    id: "RegisteredAddress",
    title: "Registered Address",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "registered-address-changes",
    disabled: true,
  },
  {
    id: "AccountReferenceDate",
    title: "Account Reference Date",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "reference-date-changes",
    disabled: true,
  },
  {
    id: "ConversionOfACompany",
    title: "Conversion of a company",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "company-conversion-changes",
    disabled: true,
  },
  {
    id: "StrikeOff",
    title: "Strike Off",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "strike-off-changes",
    disabled: true,
  },
  {
    id: "BankAccount",
    title: "Bank Account(s)",
    description:
      "Maintain the particulars of your Bank Account(s) with just a few clicks.",
    icon: <BriefcaseIcon />,
    hash: "bank-accounts-changes",
    disabled: true,
  },
  {
    id: "NameOfACompany",
    title: "Name of a company",
    description:
      "Initiate a new application with just a few clicks and you will be on your way.",
    icon: <BriefcaseIcon />,
    hash: "company-name-changes",
    disabled: true,
  },
];

export default companyChangeProcesses;
